import axios from 'axios';
import cookies from 'vue-cookies';
import router from '@/router/index';

const Hover = {

  state: {
    hover: false,
    temp: {
      title: '',
      type: '',
      content: [],
      x: null,
      y: null
    }
  },

  getters: {

    getHoverTemp: state => () => {
      return state.temp;
    }

  },

  mutations: {

    setHoverTemp(state, temp) {
      state.hover = true;
      state.temp = temp.title ?
        temp :
        {
          title: '',
          type: '',
          content: [],
          x: null,
          y: null
        };
      state.hover = temp.title ? true : false;
    },

    submitHover(state, temp){
      state.hover = true;
      state.temp = temp;
    },

    resetHover(state) {
      state.hover = false;
      state.temp = {
        title: '',
        type: '',
        content: [],
        x: null,
        y: null
      }
    }

  },

  actions: {

    setHoverTempFromComponent(context, temp) {
      context.commit('setHoverTemp', temp);
    },

    getHoverFromTemp(context, params) {
      let hoverObj = {};
      if (context.state.temp.x == null) {
        hoverObj.x = params.x;
        hoverObj.y = params.y;
      }
      if (!params.temp) {
        Object.keys(params).forEach(i => {
          if (!['x', 'y'].includes(i)) hoverObj[i] = params[i]
        });
      } else {
        const instance = params.temp[params.instance];
        hoverObj.type = instance.type;
        hoverObj.title = accumReplacers(params.replacers ? params.replacers : [], instance.title);
        hoverObj.content = instance.content.map(c => {
          return {
            sub: accumReplacers(params.replacers ? params.replacers : [], c.sub ? c.sub : ''),
            body: accumReplacers(params.replacers ? params.replacers : [], c.body ? c.body : '', true)
          }
        });
      }
      context.commit('submitHover', hoverObj);
    },

    destroyHover(context){
      context.commit('resetHover');
    }

  }

};

function accumReplacers(replacers, str, lower){
  if (!str.includes('{')) {
    return !lower ? upperCased(str) : str;
  } else {
    let replaced = str.split(' ').map(i => {
      replacers.forEach(r => {
        if (r.from == i) {
          i = r.to;
        }
      });
      return i;
    }).join(' ');
    return !lower ? upperCased(replaced) : replaced;
  }
}

function upperCased(str){
  return str.split(' ').map(i => `${i[0].toUpperCase()}${i.substring(1, i.length)}`).join(' ');
}

export default Hover;



// WEBPACK FOOTER //
// ./src/store/hover.js